import React, { useEffect } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core/";
import { useSelector } from "react-redux";
import Aux from "../../../hoc/Auxilliary";
import mainLogo from "../../../assests/Footerlogo.png";
import localizedStrings from "../../../utils/localize";
const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    padding: "2rem 0",
    justifyContent: "space-between",
    margin: "0 auto",
    alignItems: "flex-start",
  },
  footerItem: {
    width: "16%",
    [theme.breakpoints.down("sm")]: {
      width: "33%",
      margin: "0 auto",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      margin: "0 auto",
    },
  },
  footerItem1: {
    width: "fit-content",
    [theme.breakpoints.down("sm")]: {
      width: "33%",
      margin: "0 auto",
    },
    [theme.breakpoints.down("md")]: {
      width: "34%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      margin: "0 auto",
    },
  },
  logoPlace: {
    width: "60%",
    padding: "4px",
    [theme.breakpoints.down("xs")]: {
      width: "30%",
    },
  },
  about: {
    display: "flex",
    flexDirection: "column",
  },
  footerText: {
    color: "#fff",
    fontSize: "0.8rem",
  },
  footerHead: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#fff",
    textTransform: "uppercase",
    borderBottom: "1px solid white",
    width: "100%",
    paddingBottom: "6px",
  },
  footerMenuList: {
    listStyle: "none",
    margin: "0",
    padding: "0.5rem 0",
  },
  menuFooter: {
    color: "#fff",
    marginTop: "6px",
  },
  footerContact: {
    display: "flex",
    flexDirection: "column",
    color: "#fff",
  },
}));

const FooterItems = (props) => {
  const classes = useStyle(props);
  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Aux>
      <Grid container item className={classes.root}>
        <Grid container item className={classes.footerItem}>
          {" "}
        </Grid>
        <Grid container item className={classes.footerItem}>
          <Typography component="div" className={classes.about}>
            <div className={classes.logoPlace}>
              <img src={mainLogo} width="100%" alt="oneWorld logo" />
            </div>
          </Typography>
        </Grid>

        <Grid container item className={classes.footerItem1}>
          <Typography component="h2" className={classes.footerHead}>
            {localizedStrings.footer.contactUs.contactUs}
          </Typography>
          <Typography component="div" className={classes.footerContact}>
            <Typography
              style={{
                display: "flex",
                fontSize: "14px",
                alignItems: "center",
                width: "100%",
              }}
              component="div"
            >
              Aide technique -
              <Typography
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                  color: "#fff",
                  marginLeft: "6px",
                }}
              >
                {" "}
                <span>
                  {" "}
                  <a
                    href="mailto:sti@ustboniface.ca"
                    style={{ color: "white" }}
                  >
                    sti@ustboniface.ca
                  </a>
                </span>
              </Typography>
            </Typography>

            <Typography
              component="div"
              style={{ display: "flex", fontSize: "14px", color: "#fff" }}
            >
              Registrariat -{" "}
              <Typography
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                  color: "#fff",
                  marginLeft: "6px",
                }}
              >
                <span>
                  <a
                    href="mailto:registraire@ustboniface.ca"
                    style={{ color: "white" }}
                  >
                    registraire@ustboniface.ca
                  </a>
                </span>
              </Typography>
            </Typography>
            <Typography
              component="div"
              style={{ display: "flex", fontSize: "14px", color: "#fff" }}
            >
              Finances -{" "}
              <Typography
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "14px",
                  color: "#fff",
                  marginLeft: "6px",
                }}
              >
                <span>
                  <a
                    href="mailto:finances@ustboniface.ca"
                    style={{ color: "white" }}
                  >
                    finances@ustboniface.ca
                  </a>
                </span>
              </Typography>
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default FooterItems;
